<script setup lang="ts">
  import { IconImage, Tooltip } from '@/shared/ui';
  import PencilIcon from '@/shared/assets/icons/PencilGray.svg';
  import Trash from '@/shared/assets/icons/TrashIcon.svg';
  import { computed } from 'vue';
  import type { Branch } from '@/entities/Branch';
  import { useRouter } from 'vue-router';
  import { formatInstantToPtBR } from '@/shared/lib';

  const props = defineProps<{
    branch: Branch;
  }>();

  const emit = defineEmits<{
    delete: [id: number];
  }>();

  const router = useRouter();

  const isMatrizBranch = computed(() => {
    return props.branch.isMain !== undefined ? props.branch.isMain : props.branch.name === 'Matriz';
  });

  const memberCount = computed(() => {
    return props.branch._count?.Member ?? props.branch._count?.UserBranch ?? 0;
  });

  const handleEdit = (id: number) => {
    router.push(`filiais/${id}`);
  };

  const handleDelete = () => {
    if (isMatrizBranch.value) {
      return;
    }
    emit('delete', props.branch.id);
  };
</script>

<template>
  <tr class="border-t border-gray-02 table-row-hover">
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ branch.name }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ memberCount }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left">
      {{ formatInstantToPtBR(branch.createdAt) }}
    </td>
    <td class="pl-6 py-4.5 text-sm text-gray-07 text-left w-30">
      <div class="flex gap-2 items-center text-gray-xx-02">
        <Tooltip
          content="Editar"
          placement="top"
          class="flex items-center"
        >
          <button @click="handleEdit(branch.id)">
            <IconImage
              :src="PencilIcon"
              alt="Editar"
            />
          </button>
        </Tooltip>
        <Tooltip
          :content="isMatrizBranch ? 'Não é possível deletar a filial Matriz' : 'Deletar'"
          placement="top"
          class="flex items-center"
        >
          <button
            :disabled="isMatrizBranch"
            :class="{
              'opacity-50 cursor-not-allowed': isMatrizBranch,
              'cursor-pointer': !isMatrizBranch,
            }"
            :aria-label="
              isMatrizBranch ? 'Não é possível deletar a filial Matriz' : 'Deletar filial'
            "
            @click="handleDelete"
          >
            <IconImage
              :src="Trash"
              :alt="isMatrizBranch ? 'Deletar (desabilitado)' : 'Deletar'"
            />
          </button>
        </Tooltip>
      </div>
    </td>
  </tr>
</template>
